<div class="overlay create-batch-alert">

    <div class="overlay-body create-progress">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <p>Creating Batch Attention Items</p>

                    <mat-progress-bar  mode="indeterminate" ></mat-progress-bar>
                    <p>Please wait, your batch attention item is being created</p>
                 </div>
            </div>
        </div>       
    </div>


</div>